var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "manual-venue-entry" }, [
    _c("h4", [_vm._v("Add Venue Manually")]),
    _c("div", { staticClass: "field" }, [
      _c("label", { staticClass: "label" }, [_vm._v("Venue Name")]),
      _c("div", { staticClass: "control" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.venue.name,
              expression: "venue.name"
            }
          ],
          staticClass: "input",
          attrs: { type: "text", placeholder: "Venue name", required: "" },
          domProps: { value: _vm.venue.name },
          on: {
            input: function($event) {
              if ($event.target.composing) return
              _vm.$set(_vm.venue, "name", $event.target.value)
            }
          }
        })
      ])
    ]),
    _c("div", { staticClass: "field" }, [
      _c("label", { staticClass: "label" }, [_vm._v("Venue Type")]),
      _c("div", { staticClass: "control" }, [
        _c("div", { staticClass: "select" }, [
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.venue.type,
                  expression: "venue.type"
                }
              ],
              on: {
                change: function($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function(o) {
                      return o.selected
                    })
                    .map(function(o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.$set(
                    _vm.venue,
                    "type",
                    $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                  )
                }
              }
            },
            [
              _c("option", { attrs: { value: "" } }, [
                _vm._v("Select a type...")
              ]),
              _c("option", [_vm._v("Theater")]),
              _c("option", [_vm._v("Live Music")]),
              _c("option", [_vm._v("Burlesque")]),
              _c("option", [_vm._v("Comedy")]),
              _c("option", [_vm._v("Cafe")]),
              _c("option", [_vm._v("Cabaret/Variety")]),
              _c("option", [_vm._v("Event Space")]),
              _c("option", [_vm._v("Mixed Use")])
            ]
          )
        ])
      ])
    ]),
    _c("div", { staticClass: "field" }, [
      _c("label", { staticClass: "label" }, [_vm._v("Address")]),
      _c(
        "div",
        { staticClass: "control has-icons-left" },
        [
          _c("GmapAutocomplete", {
            staticClass: "input",
            attrs: {
              placeholder: "Search for address or enter manually",
              value: _vm.venue.address,
              options: _vm.autocompleteOptions
            },
            on: {
              place_changed: _vm.setAddressFromGoogle,
              input: _vm.onAddressInput
            }
          }),
          _vm._m(0)
        ],
        1
      ),
      _c("p", { staticClass: "help" }, [
        _vm._v("Start typing to search, or enter the address manually")
      ])
    ]),
    _c("div", { staticClass: "columns" }, [
      _c("div", { staticClass: "column" }, [
        _c("div", { staticClass: "field" }, [
          _c("label", { staticClass: "label" }, [_vm._v("City")]),
          _c("div", { staticClass: "control" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.venue.city,
                  expression: "venue.city"
                }
              ],
              staticClass: "input",
              attrs: { type: "text", placeholder: "City" },
              domProps: { value: _vm.venue.city },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.venue, "city", $event.target.value)
                }
              }
            })
          ])
        ])
      ]),
      _c("div", { staticClass: "column is-narrow" }, [
        _c("div", { staticClass: "field" }, [
          _c("label", { staticClass: "label" }, [_vm._v("State/Province")]),
          _c("div", { staticClass: "control" }, [
            _c("div", { staticClass: "select" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.venue.state,
                      expression: "venue.state"
                    }
                  ],
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.venue,
                        "state",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    }
                  }
                },
                [
                  _c("option", { attrs: { value: "" } }, [_vm._v("Select...")]),
                  _c(
                    "optgroup",
                    { attrs: { label: "United States" } },
                    _vm._l(_vm.usStates, function(state) {
                      return _c(
                        "option",
                        { key: state.abbr, domProps: { value: state.name } },
                        [_vm._v(" " + _vm._s(state.name) + " ")]
                      )
                    }),
                    0
                  ),
                  _c(
                    "optgroup",
                    { attrs: { label: "Canada" } },
                    _vm._l(_vm.canadaProvinces, function(province) {
                      return _c(
                        "option",
                        {
                          key: province.abbr,
                          domProps: { value: province.name }
                        },
                        [_vm._v(" " + _vm._s(province.name) + " ")]
                      )
                    }),
                    0
                  )
                ]
              )
            ])
          ])
        ])
      ])
    ]),
    _c("div", { staticClass: "columns" }, [
      _c("div", { staticClass: "column is-narrow" }, [
        _c("div", { staticClass: "field" }, [
          _c("label", { staticClass: "label" }, [_vm._v("Zip/Postal Code")]),
          _c("div", { staticClass: "control" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.venue.zip,
                  expression: "venue.zip"
                }
              ],
              staticClass: "input",
              staticStyle: { width: "150px" },
              attrs: { type: "text", placeholder: "Zip/Postal Code" },
              domProps: { value: _vm.venue.zip },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.venue, "zip", $event.target.value)
                }
              }
            })
          ])
        ])
      ]),
      _c("div", { staticClass: "column is-narrow" }, [
        _c("div", { staticClass: "field" }, [
          _c("label", { staticClass: "label" }, [_vm._v("Country")]),
          _c("div", { staticClass: "control" }, [
            _c("div", { staticClass: "select" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.venue.country,
                      expression: "venue.country"
                    }
                  ],
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.venue,
                        "country",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    }
                  }
                },
                [
                  _c("option", { attrs: { value: "" } }, [_vm._v("Select...")]),
                  _c("option", { attrs: { value: "United States" } }, [
                    _vm._v("United States")
                  ]),
                  _c("option", { attrs: { value: "Canada" } }, [
                    _vm._v("Canada")
                  ])
                ]
              )
            ])
          ])
        ])
      ])
    ]),
    _c("div", { staticClass: "columns" }, [
      _c("div", { staticClass: "column" }, [
        _c("div", { staticClass: "field" }, [
          _c("label", { staticClass: "label" }, [_vm._v("Website")]),
          _c("div", { staticClass: "control" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.venue.website,
                  expression: "venue.website"
                }
              ],
              staticClass: "input",
              attrs: { type: "url", placeholder: "https://example.com" },
              domProps: { value: _vm.venue.website },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.venue, "website", $event.target.value)
                }
              }
            })
          ])
        ])
      ]),
      _c("div", { staticClass: "column is-narrow" }, [
        _c("div", { staticClass: "field" }, [
          _c("label", { staticClass: "label" }, [_vm._v("Phone")]),
          _c("div", { staticClass: "control" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.venue.phone,
                  expression: "venue.phone"
                }
              ],
              staticClass: "input",
              staticStyle: { width: "180px" },
              attrs: { type: "tel", placeholder: "(555) 555-5555" },
              domProps: { value: _vm.venue.phone },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.venue, "phone", $event.target.value)
                }
              }
            })
          ])
        ])
      ])
    ]),
    _c("div", { staticClass: "buttons" }, [
      _c("button", { staticClass: "button", on: { click: _vm.cancel } }, [
        _vm._v("Cancel")
      ]),
      _c(
        "button",
        {
          staticClass: "button is-primary",
          attrs: { disabled: !_vm.isValid },
          on: { click: _vm.saveVenue }
        },
        [_vm._v(" Save Venue ")]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small is-left" }, [
      _c("i", { staticClass: "fas fa-search" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }